var Alert = (function () {
    function Alert(message, caption, info, type, tooltip) {
        if (caption === void 0) { caption = 'alert'; }
        if (info === void 0) { info = ''; }
        if (type === void 0) { type = 'success'; }
        if (tooltip === void 0) { tooltip = 'details'; }
        this.myCaption = caption;
        this.myMessage = message;
        this.myInfo = info;
        this.myType = type;
        this.myTooltip = tooltip;
    }
    Object.defineProperty(Alert.prototype, "caption", {
        get: function () {
            return this.myCaption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Alert.prototype, "message", {
        get: function () {
            return this.myMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Alert.prototype, "info", {
        get: function () {
            return this.myInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Alert.prototype, "tooltip", {
        get: function () {
            return this.myTooltip;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Alert.prototype, "type", {
        get: function () {
            return this.myType;
        },
        enumerable: false,
        configurable: true
    });
    return Alert;
}());
export { Alert };
